import { PaginationRequest } from "../../objects/pagination";
import { customFetch } from "../../utils/http";

export const getAdmins = async (req: PaginationRequest) => {
  const queryParams = new URLSearchParams();
  queryParams.set("page", String(req.page));
  queryParams.set("size", String(req.size));
  if (req.search) queryParams.set("search", req.search);
  return await customFetch(`v1/system/admin?${queryParams}`, {
    method: "GET",
  });
};

export const createAdmin = async (
  full_name: string,
  email: string,
  password: string,
  role_id?: string
) => {
  return await customFetch(`v1/system/admin`, {
    method: "POST",
    body: JSON.stringify({ full_name, email, password, role_id }),
  });
};

export const updateAdmin = async (id: string, data: any) => {
  return await customFetch(`v1/system/admin/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
};

export const getRoles = async (req: PaginationRequest, mode: string) => {
  const queryParams = new URLSearchParams();
  queryParams.set("page", String(req.page));
  queryParams.set("size", String(req.size));
  if (mode == "admin") {
    queryParams.set("is_admin", "1");
  }
  if (mode == "merchant") {
    queryParams.set("is_merchant", "1");
  }
  return await customFetch(`v1/system/roles?${queryParams}`, {
    method: "GET",
  });
};

export const createRole = async (data: any) => {
  return await customFetch(`v1/system/roles`, {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export const updateRole = async (id: string, data: any) => {
  return await customFetch(`v1/system/roles/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
};
export const getPermissions = async () => {
  return await customFetch(`v1/system/permissions`, {
    method: "GET",
  });
};


export const getSetting = async () => {
  return await customFetch(`v1/system/setting`, {
    method: "GET",
  });
};

export const updateSetting = async (data: any) => {
  return await customFetch(`v1/system/setting`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
};


export const getBankCode = async () => {
  return await customFetch(`v1/system/bank-code`, {
    method: "GET",
  });
};
export const getVACode = async () => {
  return await customFetch(`v1/system/va-code`, {
    method: "GET",
  });
};
export const getEWalletCode = async () => {
  return await customFetch(`v1/system/ewallet-code`, {
    method: "GET",
  });
};

export const createPaymentFee = async (data: any) => {
  return await customFetch(`v1/system/payment-fee`, {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export const deletePaymentFeeById = async (id: string) => {
  return await customFetch(`v1/system/payment-fee/${id}`, {
    method: "DELETE",
  });
};

